import { Button } from "primereact/button";

const EditorActionBar = ({
  loading,
  headerData,
  permittedToEdit,
  isPnjTransport,
  handleOnClickBack,
  handleOnClickSaveHeader,
  handleOnClickReload
}) => {
  return (
    <div className="elevated-card-tight-vertical w-100 row-between-start relative wrap gap-8">
      <div className="row-start-center gap-2">
        <Button
          className="max-h-[2.5rem] min-w-[3rem]"
          icon="pi pi-arrow-left"
          severity="danger"
          onClick={handleOnClickBack}
        />{" "}
      </div>
      <div className="row-end-center gap-2">
        <Button
          icon="pi pi-save"
          size="small"
          loading={loading}
          severity="success"
          onClick={handleOnClickSaveHeader}
          rounded
          disabled={!permittedToEdit && !isPnjTransport}
        />
        <Button
          disabled={headerData.id ? false : true}
          icon="pi pi-refresh"
          size="small"
          loading={loading}
          onClick={handleOnClickReload}
          rounded
          outlined
        />
      </div>
    </div>
  );
};

export default EditorActionBar;
